var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4141 7.65234C12.0586 7.54297 11.7031 7.73438 11.5938 8.08984C11.0195 10.1406 9.10547 11.5625 6.97266 11.5625C5.14062 11.5625 3.5 10.5234 2.67969 8.9375H5.44141C5.79688 8.9375 6.09766 8.66406 6.09766 8.28125C6.09766 7.92578 5.82422 7.625 5.44141 7.625H1.06641C0.710938 7.625 0.410156 7.92578 0.410156 8.28125V12.6562C0.410156 13.0391 0.710938 13.3125 1.06641 13.3125C1.44922 13.3125 1.72266 13.0391 1.72266 12.6562V9.86719C2.81641 11.6992 4.8125 12.875 6.97266 12.875C9.67969 12.875 12.0859 11.0703 12.8516 8.47266C12.9609 8.11719 12.7695 7.76172 12.4141 7.65234ZM12.9062 0.1875C12.5234 0.1875 12.25 0.488281 12.25 0.84375V3.66016C11.1562 1.82812 9.16016 0.625 7 0.625C4.29297 0.625 1.85938 2.45703 1.09375 5.05469C1.01172 5.38281 1.20312 5.76562 1.55859 5.84766C1.91406 5.95703 2.26953 5.76562 2.35156 5.41016C2.95312 3.38672 4.86719 1.9375 7 1.9375C8.80469 1.9375 10.4453 3.00391 11.2656 4.5625H8.53125C8.14844 4.5625 7.875 4.86328 7.875 5.21875C7.875 5.60156 8.14844 5.875 8.53125 5.875H12.9062C13.2617 5.875 13.5625 5.60156 13.5625 5.21875V0.84375C13.5625 0.488281 13.2617 0.1875 12.9062 0.1875Z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.2df4053f8131f93115c197d9cebe09df.svg";
export { ForwardRef as ReactComponent };